(function () {
  window.ScarabQueue = window.ScarabQueue || [];

  var DEBOUNCE_MS = 300;

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function toScarabItem(item) {
    return {
      item: item.sku || String(item.variant_id),
      price: item.final_line_price / 100,
      quantity: item.quantity,
    };
  }

  function pushAvailabilityZone() {
    var zone = window.EmarsysTheme && window.EmarsysTheme.availabilityZone;
    if (zone) window.ScarabQueue.push(["availabilityZone", zone]);
  }

  function pushIdentity() {
    var email = window.EmarsysTheme && window.EmarsysTheme.email;
    if (email) window.ScarabQueue.push(["setEmail", email]);
  }

  function sendCart() {
    var cartUrl = (window.routes && window.routes.cart_url) || "/cart";

    fetch(cartUrl + ".js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart fetch failed");
        return response.json();
      })
      .then(function (cart) {
        pushAvailabilityZone();
        pushIdentity();
        window.ScarabQueue.push(["cart", cart.items.map(toScarabItem)]);
        window.ScarabQueue.push(["go"]);
      })
      .catch(function () {});
  }

  function sendView(variant) {
    if (!variant) return;
    pushAvailabilityZone();
    pushIdentity();
    window.ScarabQueue.push(["view", variant.sku || String(variant.id)]);
    window.ScarabQueue.push(["go"]);
  }

  function initialize() {
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, debounce(sendCart, DEBOUNCE_MS));

    var theme = window.EmarsysTheme;
    if (!theme || theme.template !== "product") return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant || !theme.variantIds || theme.variantIds.indexOf(variant.id) === -1) return;
      sendView(variant);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
